import { render } from "./PrintInstantReportModal.vue?vue&type=template&id=44ab2aac"
import script from "./PrintInstantReportModal.vue?vue&type=script&lang=js"
export * from "./PrintInstantReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__